import classNames from 'classnames';
import React from 'react';
import Icon from '../../wui-icon/src';
import {prefix, WebUI, getNid} from "../../wui-core/src/index"
import { ModalHeaderProps } from './iModal';
import ModalContext from './ModalContext';

const defaultProps: Partial<ModalHeaderProps> = {
    'aria-label': 'Close',
    closeButton: false,
    clsPrefix: `${prefix}-modal-header`
};

const ModalHeader: React.FC<ModalHeaderProps> = (props) => {
    const {
        'aria-label': label = defaultProps['aria-label'] as string,
        /* eslint-disable */
        renderMaximizeButton,
        closeButton = defaultProps.closeButton as boolean,
        className,
        draggable,
        clsPrefix = defaultProps.clsPrefix as string,
        children,
        renderCloseButton,
        closeButtonProps,
        /* eslint-disable */
        onMaximize,
        fieldid,
        id,
        dragCtrlId,
        maximize,
        ...restProps
    } = props;

    const modalContext = React.useContext(ModalContext);

    // 点击右上角关闭
    const handleCancelClick = React.useCallback(async () => {
        if (!modalContext) {
            return;
        }
        modalContext.onCancel();
    }, [modalContext]);

    const handleMaximize = React.useCallback(() => {
        if (!modalContext) {
            return;
        }
        const isMaximize = modalContext.isMaximize();
        modalContext.handleMaximize(!isMaximize);// 只处理放大缩小状态,不再处理是否显示最大化图标和最大化dom
    }, [modalContext]);

    const isMaximize = modalContext ? modalContext.isMaximize() : false;

    const classes: {[key: string]: boolean} = {};
    classes[`${clsPrefix}`] = true;
    classes[`${clsPrefix}-dnd-handle`] = !!draggable;
    classes[`${clsPrefix}-handle-${dragCtrlId}`] = !!draggable;

    const closeBtnDom = (
        <button
            {...closeButtonProps}
            type="button"
            className="close dnd-cancel"
            fieldid={fieldid ? `${fieldid}_close` : undefined}
            // 原测试脚本 id规范
            id={id ? `modalkey_${id}close` : undefined}
            aria-label={label}
            onClick={handleCancelClick}
        >
            {renderCloseButton ? renderCloseButton() :
                <Icon aria-hidden="true" type='uf-close'/>
            }
        </button>
    )

    const maximizButton = maximize ? (
        <button
            {...closeButtonProps}
            type="button"
            className="close dnd-cancel maximize"
            fieldid={fieldid ? isMaximize ? `${fieldid}_max` : `${fieldid}_min` : undefined}
            onClick={handleMaximize}
        >
            {renderMaximizeButton ? renderMaximizeButton(isMaximize) :
                <Icon className="maximize-icon" type={isMaximize ?'uf-minimize' : 'uf-maxmize'}/> }
        </button>
    ) : null;

    const adapterNid = getNid(props);

    return (
        <div
            fieldid={fieldid}
            {...restProps}
            className={classNames(className, classes)}
            {...adapterNid}
        >
            {closeButton && closeBtnDom}
            {maximizButton && maximizButton}
            {children}
        </div>
    );
}

export default WebUI({name: "modal-header", defaultProps})(ModalHeader) as React.FC<Partial<ModalHeaderProps>>;
